import { apiClient } from '../../axios';
import { fetchClient } from '../../fetch';
import { BannerParams, TypedBannerResponse } from './types';

export const getBannersApi = <T extends BannerParams>(params: T) =>
  apiClient.get<TypedBannerResponse<T>>('/v1/exchange/banners', { params: { ...params, platform: 'WEB' } });

export const fetchBannersApi = <T extends BannerParams>(params: T) =>
  fetchClient.fetch<TypedBannerResponse<T>>('/v1/exchange/banners', {
    params: { ...params, platform: 'WEB' },
    next: { tags: ['fetchBannersApi'] },
  });
